import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { API_URL } from '../../../config';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';



const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));

const ChangeDistributor5 = ({ deviceid}) => {

    const classes = useStyles();

    const [editdata, setEditdata] = useState([]);
    const [changeDistId, setChangeDistId ] = useState('');


    const [checkboxshow, setCheckboxshow] = useState(false)
    const [cmoduleval, setCmoduleval] = useState(0)
    const [mmoduleval, setMmoduleval] = useState(0)
    const [errorMessege, setErrorMessege] = useState(false);
    const [devicetype, setDevicetype] = useState(0)
    const [checkingboxmessge, setCheckingboxmessge] = useState(false);
    const [GoPersonaldefaultdata, setGoPersonaldefaultdata] = useState(5)
    const [data, setData ] = useState('');
    const [successeditdeviceModal, setSuccesseditdeviceModal] = useState(false);
    const successeditdeviceToggleModal = () => setSuccesseditdeviceModal(!successeditdeviceModal);


    useEffect(() => {
        getgodevicebyid()


    }, [])



    const HandleEditdeviceType = (e)=>{
        setChangeDistId(e.target.value);
    }

    const getgodevicebyid = () => {


        fetch(API_URL + "/get/all/distributer",
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    setData(resp.data)
                   
                    
                });
            }



        })
    }


    const editDevice = () => {
        let changeDist = {}
        changeDist['transfer_distributer'] = changeDistId;
        fetch(API_URL + "/transfer/distributer/five/by/" + deviceid, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',

            },
            body: JSON.stringify(changeDist)
        }).then((response) => {

            if (response.status == 200) {
                response.json().then((resp) => {
                    successeditdeviceToggleModal()
                    // window.location.reload()
                });
            } else if (response.status == 400) {
                devicekeyToggleModal();
            }
            else {
                alert("network error")
            }

        })

    }




    return (
        <div>
            <ul className='deviceformlist'>
                <li>
                    <div className='select-device-type'>
                                    <select onChange={HandleEditdeviceType}>
                                        <option value="null">Select distributor</option>
                                        {
                                        data.length > 0 &&
                                        data?.map((item)=>{
                                            if((item.firstname == '')||(item.lastname == '')|| (item.firstname == null)||(item.lastname == null)){

                                            }else{
                                            return (
                                                <option value={item.eid}  >{item.firstname} {item.lastname}</option>
                                            )
                                            }
                                        })
                                    }
                                    </select>
                                </div>

                </li>

                <li>
                    <div className='addBtn'>
                        <button onClick={editDevice}>Update</button>
                    </div>
                </li>

            </ul>
            <Modal isOpen={successeditdeviceModal} toggle={successeditdeviceToggleModal} className="connect-box" centered={true}>
                    <ModalHeader toggle={successeditdeviceToggleModal}><span className="ml-1 roititle ">Successfull</span></ModalHeader>
                    <ModalBody>
                        <div className='modal-paragrph'>
                            <p>Distributor has been transferred successfully</p>
                        </div>
                    </ModalBody>

                </Modal>
        </div>
    )
}

export default ChangeDistributor5;